const e = {
  name: "Sydney",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,1.6l1.6,0.5c3.6,1.2,6.2,4.1,7.2,7.6C18.9,9.3,20.1,9,21.4,9H24v2.2l-2,6V22H2v-5.8l-2-5V8.7l4,1.1V4.5
			l4.9,2.2l0.1,0V1.6z M20.3,16l1.7-5h-0.6c-2.8,0-5.3,1.7-6.4,4.3c0,0.2,0,0.5,0,0.7H20.3z M14.4,12.4c0.5-0.6,1-1.1,1.6-1.6
			c-0.6-2.8-2.4-5.1-5-6.4v3.4C12.5,9.1,13.7,10.6,14.4,12.4z M8.1,8.5L6,7.5v3.1c1.7,1,3.1,2.5,3.7,4.4h2.2l1,1H13
			C13,12.7,11.1,9.8,8.1,8.5z M7.6,15c-0.8-1.5-2.1-2.7-3.8-3.2l-1.5-0.4L3.7,15H7.6z M4,17v3h16v-2h-7.9l-1-1H4z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Sydney
};
